import { render, staticRenderFns } from "./audio6.vue?vue&type=template&id=1c427803&scoped=true"
var script = {}
import style0 from "./audio6.vue?vue&type=style&index=0&id=1c427803&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c427803",
  null
  
)

export default component.exports